export default "__VITE_ASSET__DRG1gtFm__"